export default "__VITE_ASSET__7abac4b6__"